var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.125,
    height: 12.9,
    viewBox: "0 0 16.125 12.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "comments",
    d: "M.806,4.434C.806,2.55,2.663.806,5.241.806S9.675,2.55,9.675,4.434,7.818,8.063,5.241,8.063a6.006,6.006,0,0,1-1.167-.126.393.393,0,0,0-.257.035c-.154.078-.3.151-.454.219a7.348,7.348,0,0,1-2.305.655,10.237,10.237,0,0,0,.947-1.509.4.4,0,0,0-.063-.469A3.512,3.512,0,0,1,.806,4.434ZM5.241,0C2.346,0,0,1.988,0,4.434A4.16,4.16,0,0,0,1.159,7.206a7.519,7.519,0,0,1-1,1.449h0l0,0A.607.607,0,0,0,.6,9.675,7.712,7.712,0,0,0,3.7,8.927c.123-.055.242-.113.36-.171a6.551,6.551,0,0,0,1.184.116c2.895,0,5.241-1.988,5.241-4.434S8.136,0,5.241,0Zm6.032,4.044c2.373.164,4.046,1.827,4.046,3.616a3.512,3.512,0,0,1-1.136,2.434.4.4,0,0,0-.063.469,10.591,10.591,0,0,0,.947,1.509,7.464,7.464,0,0,1-2.305-.655c-.151-.068-.3-.141-.454-.219a.4.4,0,0,0-.257-.035,5.965,5.965,0,0,1-1.167.126A4.629,4.629,0,0,1,7.027,9.441a6.793,6.793,0,0,1-.852.171,5.4,5.4,0,0,0,4.709,2.482,6.551,6.551,0,0,0,1.184-.116c.116.058.237.116.36.171a7.673,7.673,0,0,0,3.091.751.605.605,0,0,0,.443-1.015l0,0h0a7.6,7.6,0,0,1-1-1.449,4.16,4.16,0,0,0,1.159-2.771c0-2.378-2.212-4.321-4.994-4.429a4.541,4.541,0,0,1,.141.814Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/comments.e08ccbfbe59cfe306e1108c22e075f52.svg";